export default "__VITE_ASSET__870e8232__"